module.exports = __webpack_public_path__ + "static/img/200150.4372b985.png";